const { on } = window.ivent;

let toc = document.querySelector('.toc');
let activeLink = null;

on(document, 'pvs.navigation.content-rendered', () => {
	toc = document.querySelector('.toc');
});

// Set progress when link is activated.
on(document, 'pvs.toc.activated-link', ({ relatedTarget: link }) => {
	if (!toc) {
		return;
	}

	activeLink = link;

	toc.style.setProperty(
		'--toc--scroll-progress',
		`${link.offsetTop + link.getBoundingClientRect().height}px`,
	);
});

// Reset progress when link is deactivated.
on(document, 'pvs.toc.deactivated-link', ({ relatedTarget: link }) => {
	if (activeLink !== link || !toc) {
		return;
	}

	toc.style.setProperty('--toc--scroll-progress', 0);
});
